import * as THREE from 'three';
import { getMercatorScale } from './getMercatorScale';
import { averageMercatorScale } from './averageMercatorScale';
import { Coords } from './toCoords';

const earthRadius = 6378137; // in meters

/**
 * Converts geographic coordinates (latitude, longitude, altitude) to a 3D vector.
 * This function calculates the 3D position relative to a given origin point.
 * It uses the Mercator projection to convert latitude and longitude into a 3D Cartesian coordinate system.
 * @param point
 * @param origin
 * @returns
 */
export const coordsToVector3 = (point: Coords, origin: Coords): THREE.Vector3Tuple => {
  const latitudeDiff = (point.lat - origin.lat) * THREE.MathUtils.DEG2RAD;
  const longitudeDiff = (point.lng - origin.lng) * THREE.MathUtils.DEG2RAD;
  const altitudeDiff = (point.alt || 0) - (origin.alt || 0);

  const x = longitudeDiff * earthRadius * Math.cos(origin.lat * THREE.MathUtils.DEG2RAD);
  const y = altitudeDiff;

  // dynamic step size based on latitude difference. calculate the mercator unit scale at origin
  // and the scale average along the line to the point for better accuracy far from origin
  const steps = Math.ceil(Math.abs(point.lat - origin.lat)) * 100 + 1;
  const avgScale = averageMercatorScale(origin.lat, point.lat, steps);

  const z = ((-latitudeDiff * earthRadius) / getMercatorScale(origin.lat)) * avgScale;
  return [x, y, z] as THREE.Vector3Tuple;
};
